/**
 * The headline annual saving, as a whole-number percentage derived from monthly
 * x 12 price, together with the copy that quotes it
 */
const MONTHS_IN_YEAR = 12;
export const getAnnualDiscountPercentage = (monthlyPrice, yearlyPrice) => getAnnualDiscountPercentageFromStandard(Number(monthlyPrice) * MONTHS_IN_YEAR, yearlyPrice);
export const getAnnualDiscountPercentageFromStandard = (standardPrice, yearlyPrice) => {
    const standard = Number(standardPrice);
    const yearly = Number(yearlyPrice);
    if (!standard ||
        !yearly ||
        Number.isNaN(standard) ||
        Number.isNaN(yearly) ||
        yearly >= standard) {
        return undefined;
    }
    const percentage = Math.round((1 - yearly / standard) * 100);
    const remainder = percentage % 10;
    if (remainder === 1)
        return percentage - 1;
    if (remainder === 9)
        return percentage + 1;
    return percentage;
};
export const switchToYearlyText = (percentage) => percentage
    ? `Save ${percentage}%, upgrade to yearly`
    : 'Upgrade to yearly and save';
export const keepYearlyText = (percentage) => percentage ? `Keep yearly and save ${percentage}%` : 'Keep yearly and save';
export const switchPeriodToYearlyText = (percentage) => percentage
    ? `Switch to yearly and save ${percentage}%`
    : 'Switch to yearly and save';
